import { UI_COOKIE_FORM_KEY } from '@tuning-bytes/constants';
import { IVehicleInfo } from '@tuning-bytes/dto';
import { create } from 'zustand';

interface IUiProperties {
  isEnablePayment: boolean;
  isDisplaySuccesModal: boolean;
  isDisplayErrorModal: boolean;
  step: number;
  saveBillingAddress: boolean;
  isCartDisplay: boolean;
  vehicles: IVehicleInfo[];
}

const initialState: IUiProperties = {
  isCartDisplay: false,
  isEnablePayment: false,
  isDisplaySuccesModal: false,
  isDisplayErrorModal: false,
  step: 0,
  saveBillingAddress: false,
  vehicles: [],
};

interface IUiActions {
  toogleCartDisplay: () => void;
  setIsEnablePayment: (isEnablePayment: boolean) => void;
  setIsDisplaySuccesModal: (isDisplaySuccesModal: boolean) => void;
  setIsDisplayErrorModal: (isDisplayErrorModal: boolean) => void;
  resetUiStore: () => void;
  increaseStep: () => void;
  decreaseStep: () => void;
  toggleSaveBillingAddress: () => void;
  goToStep: (step: number) => void;
  setVehicles: (vehicles: IVehicleInfo[]) => void;
}
interface State extends IUiProperties, IUiActions {}

import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const partializeStore = (state: State) =>
  Object.fromEntries(
    Object.entries(state).filter(([key]) => ['step'].includes(key)),
  );

export const useUiStore = create<State>()(
  devtools(
    persist(
      immer((set) => ({
        ...initialState,
        setIsEnablePayment: (isEnablePayment: boolean) => {
          set(
            (state) => {
              state.isEnablePayment = isEnablePayment;
            },
            false,
            'ui/setIsEnablePayment',
          );
        },

        setIsDisplaySuccesModal: (isDisplaySuccesModal: boolean) => {
          set(
            (state) => {
              state.isDisplaySuccesModal = isDisplaySuccesModal;
            },
            false,
            'ui/setIsDisplaySuccesModal',
          );
        },

        setIsDisplayErrorModal: (isDisplayErrorModal: boolean) => {
          set(
            (state) => {
              state.isDisplayErrorModal = isDisplayErrorModal;
            },
            false,
            'ui/setIsDisplayErrorModal',
          );
        },

        resetUiStore: () => {
          set({ ...initialState }, false, 'ui/resetStore');
        },

        increaseStep: () => {
          set(
            (state) => {
              state.step += 1;
            },
            false,
            'ui/increaseStep',
          );
        },

        decreaseStep: () => {
          set(
            (state) => {
              state.step -= 1;
            },
            false,
            'ui/decreaseStep',
          );
        },
        toggleSaveBillingAddress: () => {
          set(
            (state) => {
              state.saveBillingAddress = !state.saveBillingAddress;
            },
            false,
            'ui/toggleSaveBillingAddress',
          );
        },
        goToStep: (step: number) => {
          set(
            (state) => {
              state.step = step;
            },
            false,
            'ui/goToStep',
          );
        },
        toogleCartDisplay: () => {
          set(
            (state) => {
              state.isCartDisplay = !state.isCartDisplay;
            },
            false,
            'ui/toogleCartDisplay',
          );
        },
        setVehicles: (vehicles: IVehicleInfo[]) => {
          set(
            (state) => {
              state.vehicles = vehicles;
            },
            false,
            'ui/setVehicles',
          );
        },
      })),
      { name: UI_COOKIE_FORM_KEY, partialize: partializeStore },
    ),
    { name: UI_COOKIE_FORM_KEY },
  ),
);
